import {
	ElementRef,
	Injectable,
	Renderer2,
	RendererStyleFlags2,
} from '@angular/core';

@Injectable()
export class ColumnsConfigViewProvider {
	private readonly GAP_PX = 77;
	private readonly PANEL_HEADER = 48;
	private readonly STEPPER_HEADER = 72;
	private readonly ALERT = 59;

	public adjustHeights(elemRef: ElementRef, renderer: Renderer2): void {
		const modalContent =
			elemRef.nativeElement.querySelector('.app-modal-content');

		const columnsDatablockList = document.querySelector(
			'#columns-datablock .app-subscription-column-config'
		) as HTMLElement | null;

		const columnsConfigList = document.querySelector(
			'#columns-properties .app-subscription-column-config'
		) as HTMLElement | null;

		const columnListHeight =
			modalContent.offsetHeight -
			this.GAP_PX -
			this.PANEL_HEADER -
			this.STEPPER_HEADER;

		if (columnsDatablockList) {
			renderer.setStyle(
				columnsDatablockList,
				'--max-height-columns',
				`${columnListHeight - this.ALERT}px`,
				RendererStyleFlags2.DashCase
			);
		}

		if (columnsConfigList) {
			renderer.setStyle(
				columnsConfigList,
				'--max-height-columns',
				`${columnListHeight}px`,
				RendererStyleFlags2.DashCase
			);
		}
	}
}
